import { useState, FC, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, StripeError } from "@stripe/stripe-js";
import { createPayment, updatePayment, assignAuthPermissions, getStripeCustomer } from "src/lib/StripeAPI";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import "./Payment.css";
import { PaymentIntent, jwtADTokenContent } from "src/lib/Types";
import jwtDecode from "jwt-decode";
import { useAuth } from "src/utils/hooks/UseAuth";
import { useNavigate } from "react-router-dom";

interface PaymentProps {}

const Payment: FC<PaymentProps> = () => {
  const { loadToken } = useAuth();
  const [clientSecret, setClientSecret] = useState({ clientSecret: "" });
  const [paymentIntent, setPaymentIntent] = useState({ paymentIntent: "" });
  const navigate = useNavigate();

  const stripeToken =
    process.env.REACT_APP_BUILD_ENVIRONMENT !== "development"
      ? "pk_live_51LnTMoHFwLkm9cc4rzTungbpKcTW9ADvyeLpYIPhjeLuFzpkI9ISPumlCFTZ3LjJI4O9Hryp31LxQBah4e5SZDrx00oeY9Dm6w"
      : "pk_test_51LnTMoHFwLkm9cc4TzjTQgpRQ2kKnCsF789gtRmIGUh3IdnDYlreY7fc6a8MGng5arrVmI5bHFkMLMicJ5ppPKw0004ISRZ1j3";
  const stripePromise = loadStripe(stripeToken);

  let userInfo: any = useLocation();

  useEffect(() => {
    navigate("/");
    const fetchData = async () => {
      let customer_id: string;
      const token = loadToken();
      if (!token) {
        navigate("/"); // error is thrown if no JWT exists
        return;
      }
      customer_id = GetStripeCustomerFromJWT(loadToken());
      const secret = await createPayment(customer_id);
      setClientSecret({ clientSecret: secret.client_secret });
      setPaymentIntent({ paymentIntent: secret.payment_intent });
    };
    fetchData();
  }, []);

  return (
    <div className="AuthPage">
      {paymentIntent.paymentIntent.length == 0 ? (
        ""
      ) : (
        <Elements stripe={stripePromise} options={clientSecret}>
          <div className="StripeForm">
            <PaymentForm paymentIntent={paymentIntent.paymentIntent} userInfo={userInfo} />
          </div>
        </Elements>
      )}
    </div>
  );
};

interface PaymentFormProps {
  paymentIntent: string;
  userInfo: any;
}

const PaymentForm: FC<PaymentFormProps> = ({ paymentIntent, userInfo }) => {
  const [error, setError] = useState("");
  const { logout } = useAuth();
  const stripe = useStripe();
  const elements = useElements();
  let navigate = useNavigate();

  const collectPayment = async () => {
    if (stripe) {
      const result: { paymentIntent?: PaymentIntent; error: StripeError } = await stripe.confirmPayment({
        // @ts-ignore
        elements,
        redirect: "if_required",
        confirmParams: {
          return_url: "http://localhost:3000/login",
        },
      });

      if (result.error) {
        setError(result.error.message ? result.error.message : "Stripe Error");
      } else if (result.paymentIntent) {
        await assignAuthPermissions(result.paymentIntent.id);
        logout();
        navigate("/", { state: { fromPurchase: true } });
      }
    }
  };

  return (
    <div className="AuthForm AuthForm--Register">
      <h3 className="AuthForm__Subheader">Payment (2 of 3)</h3>
      <h2 className="AuthForm__Header">Complete Preorder</h2>
      <p>$7 + HST (where applicable)</p>
      {error.length == 0 ? "" : <p>{error}</p>}
      <div>
        <PaymentElement />
        <button type="button" onClick={() => collectPayment()}>
          Purchase
        </button>
      </div>
    </div>
  );
};

function GetStripeCustomerFromJWT(jwt: string) {
  let token: jwtADTokenContent = jwtDecode(jwt);
  return token.extension_StripeCustomerId;
}

export default Payment;
